/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Box } from '@mui/material';
import ReportInputChart from 'pages/report/graphs/components/ReportInput/ReportInputChart';
import { createDataGraph, createListItemsName } from './helpers';

function Graph({ data, exportPdf }) {
  const { years, months } = data[0];

  return (
    <>
      {data?.map((_, indexPond, arrayPond) => {
        const dataGraph = createDataGraph(years, months, arrayPond, indexPond);
        const listItemsName = createListItemsName(arrayPond, indexPond);

        return (
          <Box
            container
            direction="column"
            justifyContent="space-around"
            alignItems="stretch"
            spacing={3}
            style={{ padding: 20 }}
          >
            <ReportInputChart
              dataGraph={dataGraph}
              itemsName={listItemsName}
              exportPdf={exportPdf}
            />
          </Box>
        );
      })}
    </>
  );
}

export default Graph;
